{
  "blocks": [
    {
      "id": "module-embryo-transfer",
      "kind": "module",
      "tags": ["treatment", "during-cycle"],
      "title": "Embryo Transfer",
      "subtitle": "Transfer of a single embryo with clinic-directed follow-up",
      "icon": "🎯",
      "body": {
        "duration": "Varies by protocol and clinic",
        "category": "treatment",
        "forWhom": "both",
        "includes": [
          "Clinic-directed endometrial preparation",
          "Transfer-day coordination recorded by your care team",
          "Procedure details and source records",
          "Ordered testing and medication instructions from your care team"
        ],
        "trackableMarkers": [
          {
            "name": "Endometrial assessment",
            "expectedToChange": false,
            "expectation": "Your clinic interprets readiness from your protocol, imaging, labs, timing, and history; there is no universal thickness or pattern rule."
          },
          {
            "name": "Ordered follow-up test",
            "expectedToChange": false,
            "expectation": "Your care team records the ordered test and follow-up plan. A single result cannot establish pregnancy location or viability by itself."
          }
        ],
        "priceRange": {
          "low": 2000,
          "high": 4000
        },
        "currency": "USD",
        "status": "coming-soon",
        "steps": [
          {
            "title": "Endometrial prep",
            "description": "Your clinic chooses the preparation, monitoring, and timing for the transfer."
          },
          {
            "title": "Transfer",
            "description": "The procedure experience and imaging approach vary; your care team records what happened and whether transfer went ahead."
          },
          {
            "title": "Luteal support",
            "description": "Follow only the medication and follow-up instructions ordered by your care team."
          }
        ]
      },
      "sources": [
        {
          "title": "Embryo transfer: evidence-based clinical guidelines",
          "journal": "Fertility and Sterility",
          "year": 2021,
          "evidenceLevel": "expert-opinion"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
